import { create } from 'zustand'

/** A single SMS recipient to pre-fill the composer's "to" section with. */
export interface SmsComposerTarget {
  /** Phone number to text — used as the recipient `contact`. */
  phone: string
  /** Display name shown in the recipient list. */
  name?: string
  /** Shipment this message is about, for history linkage. */
  shipmentId?: string
  /** Customer this recipient maps to. */
  customerId?: string
}

interface SmsComposerState {
  open: boolean
  target: SmsComposerTarget | null
  openComposer: (target: SmsComposerTarget) => void
  close: () => void
}

// Lives in `shared` (not the mass-sms feature) so lower layers — e.g. the
// shared phone-number cell rendered in tables — can open the SMS composer with
// a recipient pre-filled, without importing upward across FSD layers. The
// mass-sms feature mounts a single dialog driven by this store.
export const useSmsComposerStore = create<SmsComposerState>()((set) => ({
  open: false,
  target: null,
  openComposer: (target) => set({ open: true, target }),
  close: () => set({ open: false }),
}))

/** Open the SMS composer with a single recipient pre-filled. */
export function openSmsComposer(target: SmsComposerTarget): void {
  useSmsComposerStore.getState().openComposer(target)
}
